import { Component, OnInit, Output, EventEmitter, Input, HostListener, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert, AlertService } from '../alert.service';
//import { AlertComponent } from '../alert/alert.component';
import { APIService } from '../api.service';
import { DataService } from '../data.service';

declare var $: any;

@Component({
    selector: 'Modal-Window',
    templateUrl: './Modal-Window.component.html',
    styleUrls: ['./Modal-Window.component.css'],
    standalone: false
})
export class ModalWindowComponent implements OnInit {

  public currentAlert: Alert | undefined;
  alert: Alert | undefined;
  public icon: string = "fas";
  @Output() onClose = new EventEmitter();

  //@Input('width') public width: number;
  //@Input('height') public height: number;
  @Input('left') public left: number = 0;
  @Input('top') public top: number = 0;
  mouseClick: any;
  mouse: any;
  isDragging: Boolean | undefined;

  constructor(public alertService: AlertService, public DataService: DataService, private APIService: APIService) {  
    // this.alertService.currentAlert$.subscribe(a => {
    //   this.ngZone.run(() => {
    //     this.alert = a;
    //   });
    // });
   }

  ngOnInit() { 
    this.left = 0;
    this.top = 0;
   }

  mouseDown(event: MouseEvent) {
    this.mouseClick = { 
      x: event.clientX, 
      y: event.clientY, 
      left: this.left, 
      top: this.top 
   };
    this.isDragging = true;
  }

  mouseUp(event: MouseEvent) {
    this.isDragging = false;
  }

@HostListener('window:mousemove', ['$event'])
onMouseMove(event: MouseEvent){
   this.mouse = {
      x: event.clientX,
      y: event.clientY
   }
   if (this.isDragging == true) {
    this.left = this.mouseClick.left + (this.mouse.x -this.mouseClick.x);
    this.top = this.mouseClick.top + (this.mouse.y - this.mouseClick.y);
   }
}

  closeModal() {
    this.onClose.emit(true);
  }

  UpdateCalendarText() {
    this.APIService.updateSetting(this.DataService.Settings[0]);
    this.alertService.showChangeCalendarTextDialog = false;
  }

}